module.exports = __webpack_public_path__ + "static/images/styles/images/nations/france-cn.a329d2e7.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/france-cn.png
// module id = 3661
// module chunks = 11